import React, { useEffect, useState } from "react";
//primereact
import { Button } from "primereact/button";
//components
import Input from "../../../components/input/Input";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
//context
import { useCreateAccountContext } from "../../../context/CreateAccountContext";

const Resume = ({
  form,
  plan,
  cupom,
  bestDay,
  setCupom,
  loadingCupom,
  handleSubmit,
  validateCupom,
  loadingButton,
  appliedCoupon,
  visibleDiscount,
  setLoadingCupom,
  setVisibleDiscount,
}) => {
  const [verify, setVerify] = useState(true);
  const {
    cardState,
    pixClient,
    errorCupom,
    cardMonthly,
    baseDataForm,
    typeInterval,
    paymentMethod,
    cardInstallment,
    isFormIncomplete,
    creditCardClient,
    visiblePaymentMethods,
  } = useCreateAccountContext();

  const verifyDisabled = () => {
    if (
      !baseDataForm ||
      isFormIncomplete({
        doc: baseDataForm.doc_enterprise,
        name: baseDataForm.name_enterprise,
        email: baseDataForm.email_enterprise,
        phone: baseDataForm.phone_enterprise,
        userDoc: baseDataForm.doc,
        userName: baseDataForm.name,
        userEmail: baseDataForm.email,
        userPassword: baseDataForm.password,
      })
    ) {
      return true;
    }

    const isCardStateEmpty = Object.values(cardState).some(
      (value) => value === ""
    );

    const isCardInstallmentEmpty = Object.values(cardInstallment).some(
      (value) => value === ""
    );

    const isPixClientNull = pixClient === null;

    // const isCardMonthlyEmpty = Object.values(cardMonthly).some(
    //   (value) => value === ""
    // );

    if (typeInterval.type === "month") {
      if (paymentMethod === "pix") {
        if (
          isPixClientNull ||
          // com pagamento mensal (isCardStateEmpty && isCardMonthlyEmpty) ||
          // (!creditCardClient?.data && !creditCardClient?.address) ||
          !visiblePaymentMethods ||
          !bestDay
        ) {
          return true;
        }
      } else {
        if(paymentMethod === "card") {
          if (
            (isCardStateEmpty) ||
            // com pagamento mensal (isCardStateEmpty && isPixClientNull && isCardMonthlyEmpty) ||
            (!creditCardClient?.data && !creditCardClient?.address) ||
            !visiblePaymentMethods ||
            !bestDay
          ) {
            return true;
          }
        }
        if(paymentMethod === "installment"){
          if (
            (isCardInstallmentEmpty) ||
            // com pagamento mensal (isCardStateEmpty && isPixClientNull && isCardMonthlyEmpty) ||
            (!creditCardClient?.data && !creditCardClient?.address) ||
            !visiblePaymentMethods ||
            !bestDay
          ) {
            return true;
          }
        }
        if(!paymentMethod) {
          return true;
        }
      }
    }

    if (typeInterval.type === "year") {
      if (paymentMethod === "pix") {
        if (isPixClientNull || !visiblePaymentMethods) {
          return true;
        }
      } else {
        if (
          (isCardStateEmpty) ||
          // (isCardStateEmpty && isCardMonthlyEmpty) ||
          (!creditCardClient?.data && !creditCardClient?.address) ||
          !visiblePaymentMethods
        ) {
          return true;
        }
      }
    }

    if (!plan) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const res = verifyDisabled();
    setVerify(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    baseDataForm,
    cardState,
    pixClient,
    cardMonthly,
    plan,
    bestDay,
    creditCardClient,
    paymentMethod,
  ]);

  return (
    <div
      className="border h-100 p-4 position-relative"
      style={{
        borderRadius: "10px",
        minHeight:
          appliedCoupon && form.getValues("installments") ? "500px" : "450px",
        maxHeight:
          appliedCoupon && form.getValues("installments") ? "500px" : "450px",
      }}
    >
      <div className="row mb-3">
        <div className="col-md-6 d-flex align-items-center">
          <h3 className="fw-bolder">Resumo</h3>
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          {appliedCoupon && (
            <div
              className="px-3 py-3 rounded-pill fw-bolder text-center"
              style={{
                border: "1px solid #14B8A6",
                color: "#14B8A6",
                maxWidth: "150px",
              }}
            >
              "{appliedCoupon.name}" Ativo
            </div>
          )}
        </div>
      </div>
      <div className="row d-flex justify-content-between my-2">
        <div className="col-md-6 col-sm-5 d-flex align-items-center">
          <h5>Taxa de Adesão</h5>
        </div>
        <div className="col-md-6 col-sm-4 text-end">
          {!appliedCoupon ? (
            <h5>{formatCurrency(plan?.interval.pivot.subscription_fee)}</h5>
          ) : (
            <>
              <small className="text-muted">
                <s>{formatCurrency(plan?.interval.pivot.subscription_fee)}</s>
              </small>
              <h5>
                {formatCurrency(
                  plan?.interval.pivot.subscription_fee -
                    plan?.interval.pivot.subscription_fee *
                      appliedCoupon.subscription_fee_discount_rate
                )}
              </h5>
            </>
          )}
        </div>
      </div>
      {plan?.interval.interval === "year" && (
        <div className="row d-flex justify-content-between my-2">
          <div className="col-md-6 col-sm-5">
            <h5>Plano Anual</h5>
          </div>
          <div className="col-md-6 col-sm-4 text-end">
            {appliedCoupon ? (
              <>
                <small className="text-muted">
                  <s>
                    {formatCurrency(
                      (plan?.plan.value_total -
                        plan?.plan.value_total *
                          plan?.interval.pivot.discount_rate) *
                        12
                    )}
                  </s>
                </small>
                <h5>
                  {formatCurrency(
                    (plan?.plan.value_total -
                      plan?.plan.value_total *
                        plan?.interval.pivot.discount_rate) *
                      12 -
                      (plan?.plan.value_total -
                        plan?.plan.value_total *
                          plan?.interval.pivot.discount_rate) *
                        12 *
                        appliedCoupon.payments_discount_rate
                  )}
                </h5>
              </>
            ) : (
              <h5>
                {formatCurrency(
                  (plan?.plan.value_total -
                    plan?.plan.value_total *
                      plan?.interval.pivot.discount_rate) *
                    12
                )}
              </h5>
            )}
          </div>
          {/* {form.getValues("installments") && (
                    <h5 className="text-muted">{`Parcelado em ${form.getValues(
                      "installments"
                      )}X`}</h5>
                      )} */}
        </div>
      )}
      {form.getValues("installments") && (
        <h5 className="text-muted">{`Parcelado em ${form.getValues(
          "installments"
        )}X`}</h5>
      )}
      {bestDay && (
        <div className="row d-flex justify-content-between my-2">
          <div className="col-md-6 col-sm-5 d-flex align-items-center">
            <h5>Mensalidade</h5>
          </div>
          <div className="col-md-6 col-sm-4 text-end">
            {!appliedCoupon ? (
              <h5>
                {formatCurrency(
                  plan?.plan.value_total -
                    plan?.plan.value_total * plan?.interval.pivot.discount_rate
                )}
              </h5>
            ) : (
              <>
                <small className="text-muted">
                  <s>{formatCurrency(plan?.plan.value_total)}</s>
                </small>
                <h5>
                  {formatCurrency(
                    plan?.plan.value_total -
                      plan?.plan.value_total *
                        plan?.interval.pivot.discount_rate -
                      plan?.plan.value_total *
                        appliedCoupon.payments_discount_rate
                  )}
                </h5>
              </>
            )}
          </div>
          <h5 className="text-muted">Cobrada a partir do próximo mês</h5>
        </div>
      )}
      <div className="row d-flex justify-content-between my-2">
        <div className="col-md-5">
          <h5>Desconto</h5>
        </div>
        <div
          className="col-md-4 text-end"
          style={{ cursor: "pointer" }}
          onClick={() => setVisibleDiscount(!visibleDiscount)}
        >
          <h6 className="surface-200">
            Cupons{" "}
            {visibleDiscount ? (
              <i className="fa-solid fa-chevron-up ms-1"></i>
            ) : (
              <i className="fa-solid fa-chevron-down ms-1"></i>
            )}
          </h6>
        </div>
        {visibleDiscount && (
          <>
            <div className="col-md-12 p-inputgroup mt-3">
              <Input
                name="cupom"
                label="Cupom"
                control={form.control}
                errors={form.formState.errors}
                onChange={(e) => setCupom(e.target.value)}
              />
              <Button
                disabled={cupom.length === 0}
                loading={loadingCupom}
                label="Aplicar"
                className="ps-2"
                type="button"
                onClick={() => validateCupom(cupom, setLoadingCupom)}
              />
            </div>
            {errorCupom && (
              <div className="mt-1">
                <h6 className="text-danger">Cupom Inválido</h6>
              </div>
            )}
          </>
        )}
      </div>
      <div
        className="position-absolute start-0 end-0 mx-auto"
        style={{ width: "80%", bottom: "20px" }}
      >
        <hr />
        <div className="row d-flex justify-content-between my-2">
          <div className="col-md-5 col-sm-5 d-flex align-items-center">
            <h5 className="fw-bolder">Total</h5>
          </div>
          <div className="col-md-7 col-sm-4 text-end">
            {plan?.interval.interval === "year" ? (
              <>
                {appliedCoupon ? (
                  <>
                    <small className="text-muted">
                      <s>
                        {formatCurrency(
                          plan?.interval.pivot.subscription_fee +
                            (plan?.plan.value_total -
                              plan?.plan.value_total *
                                plan?.interval.pivot.discount_rate) *
                              12
                        )}
                      </s>
                    </small>
                    <h5 className="fs-3 fw-bolder">
                      {formatCurrency(
                        plan?.interval.pivot.subscription_fee -
                          plan?.interval.pivot.subscription_fee *
                            appliedCoupon.subscription_fee_discount_rate +
                          ((plan?.plan.value_total -
                            plan?.plan.value_total *
                              plan?.interval.pivot.discount_rate) *
                            12 -
                            (plan?.plan.value_total -
                              plan?.plan.value_total *
                                plan?.interval.pivot.discount_rate) *
                              12 *
                              appliedCoupon.payments_discount_rate)
                      )}
                    </h5>
                  </>
                ) : (
                  <h5 className="fs-3 fw-bolder">
                    {formatCurrency(
                      plan?.interval.pivot.subscription_fee +
                        (plan?.plan.value_total -
                          plan?.plan.value_total *
                            plan?.interval.pivot.discount_rate) *
                          12
                    )}
                  </h5>
                )}
              </>
            ) : appliedCoupon ? (
              <>
                <small className="text-muted">
                  <s>{formatCurrency(plan?.interval.pivot.subscription_fee)}</s>
                </small>
                <h5 className="fs-3 fw-bolder">
                  {formatCurrency(
                    plan?.interval.pivot.subscription_fee -
                      plan?.interval.pivot.subscription_fee *
                        appliedCoupon.subscription_fee_discount_rate
                  )}
                </h5>
              </>
            ) : (
              <h5 className="fs-3 fw-bolder">
                {formatCurrency(plan?.interval.pivot.subscription_fee)}
              </h5>
            )}
          </div>
        </div>
        <Button
          rounded
          type="button"
          className="w-100"
          label="Finalizar Compra"
          loading={loadingButton}
          disabled={verify}
          onClick={() => handleSubmit()}
        />
      </div>
    </div>
  );
};

export default Resume;
